/* eslint-disable react/prop-types */
// LIBRARY
import React from 'react';
import { Row, Col, Form, InputNumber, Switch, Typography } from 'antd';
import { AlphaNumInput, RegexInput, NumberInput } from 'shared_components/pattern_input';
import PropTypes from 'prop-types';
import DropDown from '../../shared/dropdown';
import { Select } from 'antd';

// CUSTOM
import showDeactivationModal from 'shared_components/deactivation_modal';
import { fieldRules, fieldLabels } from '../settings';

class InputForm extends React.Component {
	render() {
		const { ddRecords } = this.props;

		return (
			<div className="settings-exam-request-form">
				<Row gutter={12}>
					<Col span={24}>
						<Form.Item name="examRequestActive" valuePropName="checked" label="STATUS">
							<Switch 
								onChange={checked => {
									if (!checked) {
										const { examRequest, formRef, setIsForceDeactivate } = this.props;
										showDeactivationModal('Exam Request', examRequest.examRequestID, {
											itemLabel: 'Exam Request',
											onConfirm: isForce => {
												formRef.current.setFieldsValue({ examRequestActive: false });
												setIsForceDeactivate(isForce);
											},
											onCancel: () => {
												formRef.current.setFieldsValue({ examRequestActive: true });
												setIsForceDeactivate(false);
											},
										});
									} else {
										this.props.setIsForceDeactivate(false);
									}
								}}
							/>
						</Form.Item>
					</Col>
					<Col span={9}>
						<Form.Item
							name="examRequestName"
							label={fieldLabels.examName}
							rules={fieldRules.examName}
						>
							<RegexInput regex={/[A-z0-9 -]/} maxLength={254} />
						</Form.Item>
					</Col>
					<Col span={9}>
						<Form.Item
							name="examRequestCode"
							label={fieldLabels.examCode}
							rules={fieldRules.examCode}
						>
							<AlphaNumInput maxLength={50} />
						</Form.Item>
					</Col>
					<Col span={6}>
						<Form.Item label="REPORT TEMPLATE" name="examRequestReportTemplate">
							<Select options={ddRecords} />
						</Form.Item>
					</Col>
					<Col span={4} className="hide">
						<Form.Item
							name="specimenID"
							label={fieldLabels.specimenID}
							rules={fieldRules.specimenID}
						>
							<InputNumber className="fullWidth" />
						</Form.Item>
					</Col>
					<Col span={4} className="hide">
						<Form.Item name="sectionID" label={fieldLabels.sectionID} rules={fieldRules.sectionID}>
							<InputNumber className="fullWidth" />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={12}>
					<Col span={9}>
						<Form.Item name="examRequestLoinc" label={fieldLabels.loinc} rules={fieldRules.loinc}>
							<AlphaNumInput maxLength={100} />
						</Form.Item>
					</Col>
					<Col span={9}>
						<Form.Item
							name="examRequestIntegrationCode"
							label={fieldLabels.integrationCode}
							rules={fieldRules.integrationCode}
						>
							<AlphaNumInput maxLength={100} />
						</Form.Item>
					</Col>
					<Col span={6}>
						{/* <Form.Item
							name="examRequestSort"
							label={fieldLabels.examSort}
							rules={fieldRules.examSort}
						>
							<NumberInput className="fullWidth" maxLength={32} />
						</Form.Item> */}
					</Col>
				</Row>

				<Row gutter={30} style={{ marginBottom: 10 }}>
					<Col style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
						<Typography>STAT :</Typography>
						<Form.Item name="examRequestAutoSTAT" valuePropName="checked" style={{ margin: 0 }}>
							<Switch />
						</Form.Item>
					</Col>

					<Col style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
						<Typography>AUTO SEND OUT :</Typography>
						<Form.Item name="examRequestAutoSendOut" valuePropName="checked" style={{ margin: 0 }}>
							<Switch />
						</Form.Item>
					</Col>
				</Row>
			</div>
		);
	}
}

InputForm.propTypes = {
	examRequest: PropTypes.shape({
		examRequestID: PropTypes.number,
		examRequestName: PropTypes.string,
		examRequestCode: PropTypes.string,
		examRequestLoinc: PropTypes.string,
		examRequestIntegrationCode: PropTypes.string,
		examRequestSort: PropTypes.number,
		sectionID: PropTypes.number,
		specimenID: PropTypes.number,
	}),
	formRef: PropTypes.object,
};

InputForm.defaultProps = {
	examRequest: {},
};

export default InputForm;
